var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-col grid-col--12 mb--100"},[_c('h2',[_vm._v("Your Caregiving Card Deck")]),_vm._v(" "),_c('div',{staticClass:"ctt-card-wrap ctt-card-wrap--stack intro-deck",on:{"click":_vm.goToDeck}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctt-card"},[_c('div',{staticClass:"ctt-card__cont"},[_c('h3',{staticClass:"h2--sm"},[_vm._v("Care To Talk?™")])])])
}]

export { render, staticRenderFns }